import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items }) {
  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb" data-testid="breadcrumbs">
      <ol>
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;
          return (
            <li key={item.href || item.label}>
              {isLast ? (
                <span aria-current="page">{item.label}</span>
              ) : (
                <>
                  <Link to={item.href} data-testid={`breadcrumb-${idx}`}>{item.label}</Link>
                  <ChevronRight size={14} aria-hidden="true" />
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
